import { GuaranteedOfferType } from '@appTypes/App.interface'

import { getFormattedMonth } from '@utils/formatter'
import getBalanceTransferOfferDurationMonths from '@utils/getBalanceTransferOfferDurationMonths'
import getGuaranteedOfferType from '@utils/getGuaranteedOfferType'

import { ContentProps, ProductDetailType } from './Content.interface'

const balanceTransferOfferDurationContent = ({
    creditCard,
}: {
    creditCard: ContentProps['creditCard']
}) => {
    const balanceTransferOfferDurationMonths =
        getBalanceTransferOfferDurationMonths(creditCard)

    const isMarketingOffer =
        getGuaranteedOfferType({
            creditCard,
        }) === GuaranteedOfferType.MarketingOffer

    if (balanceTransferOfferDurationMonths == null) {
        return null
    }

    return {
        title: 'Balance transfer offer duration',
        value: isMarketingOffer
            ? getFormattedMonth(balanceTransferOfferDurationMonths)
            : `Up to ${getFormattedMonth(balanceTransferOfferDurationMonths)}`,
        detailType: isMarketingOffer
            ? ProductDetailType.GuaranteedExample
            : undefined,
    }
}

export default balanceTransferOfferDurationContent
